import { useEffect} from "react";
import CarouselContentLoader from "../loader/contentLoader";



const External = (props)=>
{
    useEffect(()=>{
        window.location.replace(props.ext);
    })

   return (<CarouselContentLoader></CarouselContentLoader>);
}

export default External;